import { z } from "zod";

export const bibleContentSchema = z.object({
  html: z.string(),
  css: z.string(),
});

export type BibleContent = z.infer<typeof bibleContentSchema>;
